class TabCollection {
  constructor(boxOptions, options) {
    this.className = boxOptions.boxClass
    this.box = document.querySelector(boxOptions.boxClass)
    this.btnList = this.box.querySelectorAll('.tab-title h2')
    this.contentList = this.box.querySelectorAll('.content .ul .li-box')
    this.active = 0
    this.Swiper = boxOptions.swiper
    this.swiperIds = boxOptions.swiperIds
    this.init(options)
  }
  init (opt) {
    if (!this.contentList.length) {
      return
    }

    this.contentList.forEach((i, index) => {
      new this.Swiper(`.custom-swiper-${this.swiperIds}_${index}`, {
        direction: 'horizontal',
        loop: false,
        centerInsufficientSlides: true,
        slidesPerGroup: 2,
        slidesPerView: 2,
        spaceBetween: 10,
        pagination: {
          el: `.tab-pagination_${ this.swiperIds }_${index}`
        },
        navigation: {
          nextEl: `.tab-next__${ this.swiperIds }_${index}`,
          prevEl: `.tab-prev__${ this.swiperIds }_${index}`
        },
        breakpoints: {
          1280: { //当屏幕宽度大于等于1280
            spaceBetween: 20,
            slidesPerGroup: opt.column,
            slidesPerView: opt.column
          }
        }
      })
    })

    this.btnEvent()

    this.btnList.forEach((i, index) => {
      i.addEventListener('click', () => {
        this.active = index
        this.btnEvent()
      })
    })
  }

  btnEvent () {
    this.btnList.forEach(i => i.classList.remove('active'))
    this.btnList[this.active].classList.add('active')
    this.contentList.forEach(i => i.style.display = 'none')
    this.contentList[this.active].style.display = 'block'

    setTimeout(() => {
      // this.jQuery(this.contentList[this.active].querySelector('.li')).slick('refresh')
    }, 20)
  }
}
